import React, { useState, useEffect } from "react";
import { useAppStore } from "../store/useAppStore";

const AuthPage = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const isAuthenticated = useAppStore((state) => state.isAuthenticated);
    const authError = useAppStore((state) => state.authError);
    const authLoading = useAppStore((state) => state.authLoading);
    const login = useAppStore((state) => state.login);
    const setAuthError = useAppStore((state) => state.setAuthError);
    const clearAuthError = useAppStore((state) => state.clearAuthError);

    useEffect(() => {
        if (isAuthenticated) {
            clearAuthError();
        }
    }, [isAuthenticated, clearAuthError])

    const handleAuth = async () => {
        clearAuthError();

        if (!username.length || !password.length) {
            setAuthError("Введите логин и пароль");
            return;
        }

        try {
            await login(username, password);
        } catch {
            return;
        }
    }

    return (
		<div className="sign-auth">
			<div>
				<h1>Вход в систему</h1>
				{authError ? (
					<p style={{ color: "#d32f2f", marginBottom: "12px" }}>{authError}</p>
				) : null}
				<div className="e-float">
					<input onChange={(e) => {setUsername(e.target.value)}} placeholder="Введите логин" disabled={authLoading || isAuthenticated}></input>
					<label>Введите логин</label>
				</div>
				<div className="e-float">
					<input type="password" onChange={(e) => {setPassword(e.target.value)}} placeholder="Введите пароль" disabled={authLoading || isAuthenticated}></input>
					<label>Введите пароль</label>
				</div>
                <button className="e-btn" onClick={handleAuth} disabled={authLoading || isAuthenticated}>
                    {authLoading ? "Вход..." : "Войти"}
                </button>
			</div>
		</div>
    )
}

export default AuthPage;